import { render, staticRenderFns } from "./ClientModuleLayout.vue?vue&type=template&id=445063e2&scoped=true"
import script from "./ClientModuleLayout.vue?vue&type=script&lang=js"
export * from "./ClientModuleLayout.vue?vue&type=script&lang=js"
import style0 from "./ClientModuleLayout.vue?vue&type=style&index=0&id=445063e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445063e2",
  null
  
)

export default component.exports